import React from 'react';
import PropTypes from 'prop-types';
// import * as S from './DeleteGroupModal.styled';
import OkCancelModal from '../OkCancelModal/OkCancelModal';

const LeaveGroupModal = ({
  groupCuid,
  groupName,
  onClickOk,
  onClickCancel,
}) => {
  const handleOkClick = () => {
    onClickOk && onClickOk(groupCuid);
  };
  const handleCancelClick = () => {
    onClickCancel && onClickCancel();
  };

  return OkCancelModal({
    title: 'Leave Group?',
    imageName: 'trio',
    body: (
      <div>
        <div>Are you sure you want to leave the group:</div>
        <strong>{groupName}</strong>
      </div>
    ),
    okButtonText: 'Leave',
    cancelButtonText: 'Cancel',
    onClickOk: handleOkClick,
    onClickCancel: handleCancelClick,
  });
};

LeaveGroupModal.propTypes = {
  onClickOk: PropTypes.func.isRequired,
  onClickCancel: PropTypes.func.isRequired,
  groupCuid: PropTypes.string.isRequired,
  groupName: PropTypes.string.isRequired,
};

export default LeaveGroupModal;
